module.exports = __webpack_public_path__ + "static/media/ext15.ea6edcee.jpg";